/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SeasonalRouteImport } from './routes/seasonal'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as NewHereRouteImport } from './routes/new-here'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as AgricultureRouteImport } from './routes/agriculture'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProfileIndexRouteImport } from './routes/profile.index'
import { Route as ShireNameRouteImport } from './routes/shire.$name'
import { Route as ServicesWhoDoICallRouteImport } from './routes/services.who-do-i-call'
import { Route as ServicesSmallBusinessRouteImport } from './routes/services.small-business'
import { Route as ServicesSeniorsRouteImport } from './routes/services.seniors'
import { Route as ServicesNdisRouteImport } from './routes/services.ndis'
import { Route as ServicesLegalRouteImport } from './routes/services.legal'
import { Route as ServicesGrantsRouteImport } from './routes/services.grants'
import { Route as ServicesForestTransitionRouteImport } from './routes/services.forest-transition'
import { Route as ServicesFirstHomeBuyerRouteImport } from './routes/services.first-home-buyer'
import { Route as ServicesFederalRouteImport } from './routes/services.federal'
import { Route as ServicesDigitalHelpRouteImport } from './routes/services.digital-help'
import { Route as ProfileSlugRouteImport } from './routes/profile.$slug'
import { Route as PreviewShiresRouteImport } from './routes/preview.shires'
import { Route as LocalityNameRouteImport } from './routes/locality.$name'
import { Route as LearnElectorateV2RouteImport } from './routes/learn.electorate-v2'
import { Route as EmergencyFirePreparationRouteImport } from './routes/emergency.fire-preparation'
import { Route as CivicEnrolRouteImport } from './routes/civic.enrol'
import { Route as ShireNameTransportRouteImport } from './routes/shire.$name_.transport'
import { Route as ShireNameSeniorsRouteImport } from './routes/shire.$name_.seniors'
import { Route as ShireNameSchoolsRouteImport } from './routes/shire.$name_.schools'
import { Route as ShireNameProfileRouteImport } from './routes/shire.$name_.profile'
import { Route as ShireNameHousingRouteImport } from './routes/shire.$name_.housing'
import { Route as ShireNameHealthRouteImport } from './routes/shire.$name_.health'
import { Route as ShireNameEmergencyRouteImport } from './routes/shire.$name_.emergency'
import { Route as ShireNameCouncilRouteImport } from './routes/shire.$name_.council'
import { Route as ShireNameConnectivityRouteImport } from './routes/shire.$name_.connectivity'
import { Route as ShireNameCommunityRouteImport } from './routes/shire.$name_.community'

const SeasonalRoute = SeasonalRouteImport.update({
  id: '/seasonal',
  path: '/seasonal',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const NewHereRoute = NewHereRouteImport.update({
  id: '/new-here',
  path: '/new-here',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const AgricultureRoute = AgricultureRouteImport.update({
  id: '/agriculture',
  path: '/agriculture',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessibilityRoute = AccessibilityRouteImport.update({
  id: '/accessibility',
  path: '/accessibility',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProfileRoute,
} as any)
const ShireNameRoute = ShireNameRouteImport.update({
  id: '/shire/$name',
  path: '/shire/$name',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesWhoDoICallRoute = ServicesWhoDoICallRouteImport.update({
  id: '/services/who-do-i-call',
  path: '/services/who-do-i-call',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesSmallBusinessRoute = ServicesSmallBusinessRouteImport.update({
  id: '/services/small-business',
  path: '/services/small-business',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesSeniorsRoute = ServicesSeniorsRouteImport.update({
  id: '/services/seniors',
  path: '/services/seniors',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesNdisRoute = ServicesNdisRouteImport.update({
  id: '/services/ndis',
  path: '/services/ndis',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesLegalRoute = ServicesLegalRouteImport.update({
  id: '/services/legal',
  path: '/services/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesGrantsRoute = ServicesGrantsRouteImport.update({
  id: '/services/grants',
  path: '/services/grants',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesForestTransitionRoute =
  ServicesForestTransitionRouteImport.update({
    id: '/services/forest-transition',
    path: '/services/forest-transition',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesFirstHomeBuyerRoute = ServicesFirstHomeBuyerRouteImport.update({
  id: '/services/first-home-buyer',
  path: '/services/first-home-buyer',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesFederalRoute = ServicesFederalRouteImport.update({
  id: '/services/federal',
  path: '/services/federal',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesDigitalHelpRoute = ServicesDigitalHelpRouteImport.update({
  id: '/services/digital-help',
  path: '/services/digital-help',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileSlugRoute = ProfileSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => ProfileRoute,
} as any)
const PreviewShiresRoute = PreviewShiresRouteImport.update({
  id: '/preview/shires',
  path: '/preview/shires',
  getParentRoute: () => rootRouteImport,
} as any)
const LocalityNameRoute = LocalityNameRouteImport.update({
  id: '/locality/$name',
  path: '/locality/$name',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnElectorateV2Route = LearnElectorateV2RouteImport.update({
  id: '/learn/electorate-v2',
  path: '/learn/electorate-v2',
  getParentRoute: () => rootRouteImport,
} as any)
const EmergencyFirePreparationRoute =
  EmergencyFirePreparationRouteImport.update({
    id: '/emergency/fire-preparation',
    path: '/emergency/fire-preparation',
    getParentRoute: () => rootRouteImport,
  } as any)
const CivicEnrolRoute = CivicEnrolRouteImport.update({
  id: '/civic/enrol',
  path: '/civic/enrol',
  getParentRoute: () => rootRouteImport,
} as any)
const ShireNameTransportRoute = ShireNameTransportRouteImport.update({
  id: '/shire/$name_/transport',
  path: '/shire/$name/transport',
  getParentRoute: () => rootRouteImport,
} as any)
const ShireNameSeniorsRoute = ShireNameSeniorsRouteImport.update({
  id: '/shire/$name_/seniors',
  path: '/shire/$name/seniors',
  getParentRoute: () => rootRouteImport,
} as any)
const ShireNameSchoolsRoute = ShireNameSchoolsRouteImport.update({
  id: '/shire/$name_/schools',
  path: '/shire/$name/schools',
  getParentRoute: () => rootRouteImport,
} as any)
const ShireNameProfileRoute = ShireNameProfileRouteImport.update({
  id: '/shire/$name_/profile',
  path: '/shire/$name/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ShireNameHousingRoute = ShireNameHousingRouteImport.update({
  id: '/shire/$name_/housing',
  path: '/shire/$name/housing',
  getParentRoute: () => rootRouteImport,
} as any)
const ShireNameHealthRoute = ShireNameHealthRouteImport.update({
  id: '/shire/$name_/health',
  path: '/shire/$name/health',
  getParentRoute: () => rootRouteImport,
} as any)
const ShireNameEmergencyRoute = ShireNameEmergencyRouteImport.update({
  id: '/shire/$name_/emergency',
  path: '/shire/$name/emergency',
  getParentRoute: () => rootRouteImport,
} as any)
const ShireNameCouncilRoute = ShireNameCouncilRouteImport.update({
  id: '/shire/$name_/council',
  path: '/shire/$name/council',
  getParentRoute: () => rootRouteImport,
} as any)
const ShireNameConnectivityRoute = ShireNameConnectivityRouteImport.update({
  id: '/shire/$name_/connectivity',
  path: '/shire/$name/connectivity',
  getParentRoute: () => rootRouteImport,
} as any)
const ShireNameCommunityRoute = ShireNameCommunityRouteImport.update({
  id: '/shire/$name_/community',
  path: '/shire/$name/community',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/accessibility': typeof AccessibilityRoute
  '/agriculture': typeof AgricultureRoute
  '/calendar': typeof CalendarRoute
  '/contact': typeof ContactRoute
  '/new-here': typeof NewHereRoute
  '/profile': typeof ProfileRouteWithChildren
  '/seasonal': typeof SeasonalRoute
  '/civic/enrol': typeof CivicEnrolRoute
  '/emergency/fire-preparation': typeof EmergencyFirePreparationRoute
  '/learn/electorate-v2': typeof LearnElectorateV2Route
  '/locality/$name': typeof LocalityNameRoute
  '/preview/shires': typeof PreviewShiresRoute
  '/profile/$slug': typeof ProfileSlugRoute
  '/services/digital-help': typeof ServicesDigitalHelpRoute
  '/services/federal': typeof ServicesFederalRoute
  '/services/first-home-buyer': typeof ServicesFirstHomeBuyerRoute
  '/services/forest-transition': typeof ServicesForestTransitionRoute
  '/services/grants': typeof ServicesGrantsRoute
  '/services/legal': typeof ServicesLegalRoute
  '/services/ndis': typeof ServicesNdisRoute
  '/services/seniors': typeof ServicesSeniorsRoute
  '/services/small-business': typeof ServicesSmallBusinessRoute
  '/services/who-do-i-call': typeof ServicesWhoDoICallRoute
  '/shire/$name': typeof ShireNameRoute
  '/profile/': typeof ProfileIndexRoute
  '/shire/$name/community': typeof ShireNameCommunityRoute
  '/shire/$name/connectivity': typeof ShireNameConnectivityRoute
  '/shire/$name/council': typeof ShireNameCouncilRoute
  '/shire/$name/emergency': typeof ShireNameEmergencyRoute
  '/shire/$name/health': typeof ShireNameHealthRoute
  '/shire/$name/housing': typeof ShireNameHousingRoute
  '/shire/$name/profile': typeof ShireNameProfileRoute
  '/shire/$name/schools': typeof ShireNameSchoolsRoute
  '/shire/$name/seniors': typeof ShireNameSeniorsRoute
  '/shire/$name/transport': typeof ShireNameTransportRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/accessibility': typeof AccessibilityRoute
  '/agriculture': typeof AgricultureRoute
  '/calendar': typeof CalendarRoute
  '/contact': typeof ContactRoute
  '/new-here': typeof NewHereRoute
  '/seasonal': typeof SeasonalRoute
  '/civic/enrol': typeof CivicEnrolRoute
  '/emergency/fire-preparation': typeof EmergencyFirePreparationRoute
  '/learn/electorate-v2': typeof LearnElectorateV2Route
  '/locality/$name': typeof LocalityNameRoute
  '/preview/shires': typeof PreviewShiresRoute
  '/profile/$slug': typeof ProfileSlugRoute
  '/services/digital-help': typeof ServicesDigitalHelpRoute
  '/services/federal': typeof ServicesFederalRoute
  '/services/first-home-buyer': typeof ServicesFirstHomeBuyerRoute
  '/services/forest-transition': typeof ServicesForestTransitionRoute
  '/services/grants': typeof ServicesGrantsRoute
  '/services/legal': typeof ServicesLegalRoute
  '/services/ndis': typeof ServicesNdisRoute
  '/services/seniors': typeof ServicesSeniorsRoute
  '/services/small-business': typeof ServicesSmallBusinessRoute
  '/services/who-do-i-call': typeof ServicesWhoDoICallRoute
  '/shire/$name': typeof ShireNameRoute
  '/profile': typeof ProfileIndexRoute
  '/shire/$name/community': typeof ShireNameCommunityRoute
  '/shire/$name/connectivity': typeof ShireNameConnectivityRoute
  '/shire/$name/council': typeof ShireNameCouncilRoute
  '/shire/$name/emergency': typeof ShireNameEmergencyRoute
  '/shire/$name/health': typeof ShireNameHealthRoute
  '/shire/$name/housing': typeof ShireNameHousingRoute
  '/shire/$name/profile': typeof ShireNameProfileRoute
  '/shire/$name/schools': typeof ShireNameSchoolsRoute
  '/shire/$name/seniors': typeof ShireNameSeniorsRoute
  '/shire/$name/transport': typeof ShireNameTransportRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/accessibility': typeof AccessibilityRoute
  '/agriculture': typeof AgricultureRoute
  '/calendar': typeof CalendarRoute
  '/contact': typeof ContactRoute
  '/new-here': typeof NewHereRoute
  '/profile': typeof ProfileRouteWithChildren
  '/seasonal': typeof SeasonalRoute
  '/civic/enrol': typeof CivicEnrolRoute
  '/emergency/fire-preparation': typeof EmergencyFirePreparationRoute
  '/learn/electorate-v2': typeof LearnElectorateV2Route
  '/locality/$name': typeof LocalityNameRoute
  '/preview/shires': typeof PreviewShiresRoute
  '/profile/$slug': typeof ProfileSlugRoute
  '/services/digital-help': typeof ServicesDigitalHelpRoute
  '/services/federal': typeof ServicesFederalRoute
  '/services/first-home-buyer': typeof ServicesFirstHomeBuyerRoute
  '/services/forest-transition': typeof ServicesForestTransitionRoute
  '/services/grants': typeof ServicesGrantsRoute
  '/services/legal': typeof ServicesLegalRoute
  '/services/ndis': typeof ServicesNdisRoute
  '/services/seniors': typeof ServicesSeniorsRoute
  '/services/small-business': typeof ServicesSmallBusinessRoute
  '/services/who-do-i-call': typeof ServicesWhoDoICallRoute
  '/shire/$name': typeof ShireNameRoute
  '/profile/': typeof ProfileIndexRoute
  '/shire/$name_/community': typeof ShireNameCommunityRoute
  '/shire/$name_/connectivity': typeof ShireNameConnectivityRoute
  '/shire/$name_/council': typeof ShireNameCouncilRoute
  '/shire/$name_/emergency': typeof ShireNameEmergencyRoute
  '/shire/$name_/health': typeof ShireNameHealthRoute
  '/shire/$name_/housing': typeof ShireNameHousingRoute
  '/shire/$name_/profile': typeof ShireNameProfileRoute
  '/shire/$name_/schools': typeof ShireNameSchoolsRoute
  '/shire/$name_/seniors': typeof ShireNameSeniorsRoute
  '/shire/$name_/transport': typeof ShireNameTransportRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/accessibility'
    | '/agriculture'
    | '/calendar'
    | '/contact'
    | '/new-here'
    | '/profile'
    | '/seasonal'
    | '/civic/enrol'
    | '/emergency/fire-preparation'
    | '/learn/electorate-v2'
    | '/locality/$name'
    | '/preview/shires'
    | '/profile/$slug'
    | '/services/digital-help'
    | '/services/federal'
    | '/services/first-home-buyer'
    | '/services/forest-transition'
    | '/services/grants'
    | '/services/legal'
    | '/services/ndis'
    | '/services/seniors'
    | '/services/small-business'
    | '/services/who-do-i-call'
    | '/shire/$name'
    | '/profile/'
    | '/shire/$name/community'
    | '/shire/$name/connectivity'
    | '/shire/$name/council'
    | '/shire/$name/emergency'
    | '/shire/$name/health'
    | '/shire/$name/housing'
    | '/shire/$name/profile'
    | '/shire/$name/schools'
    | '/shire/$name/seniors'
    | '/shire/$name/transport'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/accessibility'
    | '/agriculture'
    | '/calendar'
    | '/contact'
    | '/new-here'
    | '/seasonal'
    | '/civic/enrol'
    | '/emergency/fire-preparation'
    | '/learn/electorate-v2'
    | '/locality/$name'
    | '/preview/shires'
    | '/profile/$slug'
    | '/services/digital-help'
    | '/services/federal'
    | '/services/first-home-buyer'
    | '/services/forest-transition'
    | '/services/grants'
    | '/services/legal'
    | '/services/ndis'
    | '/services/seniors'
    | '/services/small-business'
    | '/services/who-do-i-call'
    | '/shire/$name'
    | '/profile'
    | '/shire/$name/community'
    | '/shire/$name/connectivity'
    | '/shire/$name/council'
    | '/shire/$name/emergency'
    | '/shire/$name/health'
    | '/shire/$name/housing'
    | '/shire/$name/profile'
    | '/shire/$name/schools'
    | '/shire/$name/seniors'
    | '/shire/$name/transport'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/accessibility'
    | '/agriculture'
    | '/calendar'
    | '/contact'
    | '/new-here'
    | '/profile'
    | '/seasonal'
    | '/civic/enrol'
    | '/emergency/fire-preparation'
    | '/learn/electorate-v2'
    | '/locality/$name'
    | '/preview/shires'
    | '/profile/$slug'
    | '/services/digital-help'
    | '/services/federal'
    | '/services/first-home-buyer'
    | '/services/forest-transition'
    | '/services/grants'
    | '/services/legal'
    | '/services/ndis'
    | '/services/seniors'
    | '/services/small-business'
    | '/services/who-do-i-call'
    | '/shire/$name'
    | '/profile/'
    | '/shire/$name_/community'
    | '/shire/$name_/connectivity'
    | '/shire/$name_/council'
    | '/shire/$name_/emergency'
    | '/shire/$name_/health'
    | '/shire/$name_/housing'
    | '/shire/$name_/profile'
    | '/shire/$name_/schools'
    | '/shire/$name_/seniors'
    | '/shire/$name_/transport'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccessibilityRoute: typeof AccessibilityRoute
  AgricultureRoute: typeof AgricultureRoute
  CalendarRoute: typeof CalendarRoute
  ContactRoute: typeof ContactRoute
  NewHereRoute: typeof NewHereRoute
  ProfileRoute: typeof ProfileRouteWithChildren
  SeasonalRoute: typeof SeasonalRoute
  CivicEnrolRoute: typeof CivicEnrolRoute
  EmergencyFirePreparationRoute: typeof EmergencyFirePreparationRoute
  LearnElectorateV2Route: typeof LearnElectorateV2Route
  LocalityNameRoute: typeof LocalityNameRoute
  PreviewShiresRoute: typeof PreviewShiresRoute
  ServicesDigitalHelpRoute: typeof ServicesDigitalHelpRoute
  ServicesFederalRoute: typeof ServicesFederalRoute
  ServicesFirstHomeBuyerRoute: typeof ServicesFirstHomeBuyerRoute
  ServicesForestTransitionRoute: typeof ServicesForestTransitionRoute
  ServicesGrantsRoute: typeof ServicesGrantsRoute
  ServicesLegalRoute: typeof ServicesLegalRoute
  ServicesNdisRoute: typeof ServicesNdisRoute
  ServicesSeniorsRoute: typeof ServicesSeniorsRoute
  ServicesSmallBusinessRoute: typeof ServicesSmallBusinessRoute
  ServicesWhoDoICallRoute: typeof ServicesWhoDoICallRoute
  ShireNameRoute: typeof ShireNameRoute
  ShireNameCommunityRoute: typeof ShireNameCommunityRoute
  ShireNameConnectivityRoute: typeof ShireNameConnectivityRoute
  ShireNameCouncilRoute: typeof ShireNameCouncilRoute
  ShireNameEmergencyRoute: typeof ShireNameEmergencyRoute
  ShireNameHealthRoute: typeof ShireNameHealthRoute
  ShireNameHousingRoute: typeof ShireNameHousingRoute
  ShireNameProfileRoute: typeof ShireNameProfileRoute
  ShireNameSchoolsRoute: typeof ShireNameSchoolsRoute
  ShireNameSeniorsRoute: typeof ShireNameSeniorsRoute
  ShireNameTransportRoute: typeof ShireNameTransportRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/seasonal': {
      id: '/seasonal'
      path: '/seasonal'
      fullPath: '/seasonal'
      preLoaderRoute: typeof SeasonalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new-here': {
      id: '/new-here'
      path: '/new-here'
      fullPath: '/new-here'
      preLoaderRoute: typeof NewHereRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agriculture': {
      id: '/agriculture'
      path: '/agriculture'
      fullPath: '/agriculture'
      preLoaderRoute: typeof AgricultureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accessibility': {
      id: '/accessibility'
      path: '/accessibility'
      fullPath: '/accessibility'
      preLoaderRoute: typeof AccessibilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/shire/$name': {
      id: '/shire/$name'
      path: '/shire/$name'
      fullPath: '/shire/$name'
      preLoaderRoute: typeof ShireNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/who-do-i-call': {
      id: '/services/who-do-i-call'
      path: '/services/who-do-i-call'
      fullPath: '/services/who-do-i-call'
      preLoaderRoute: typeof ServicesWhoDoICallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/small-business': {
      id: '/services/small-business'
      path: '/services/small-business'
      fullPath: '/services/small-business'
      preLoaderRoute: typeof ServicesSmallBusinessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/seniors': {
      id: '/services/seniors'
      path: '/services/seniors'
      fullPath: '/services/seniors'
      preLoaderRoute: typeof ServicesSeniorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/ndis': {
      id: '/services/ndis'
      path: '/services/ndis'
      fullPath: '/services/ndis'
      preLoaderRoute: typeof ServicesNdisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/legal': {
      id: '/services/legal'
      path: '/services/legal'
      fullPath: '/services/legal'
      preLoaderRoute: typeof ServicesLegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/grants': {
      id: '/services/grants'
      path: '/services/grants'
      fullPath: '/services/grants'
      preLoaderRoute: typeof ServicesGrantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/forest-transition': {
      id: '/services/forest-transition'
      path: '/services/forest-transition'
      fullPath: '/services/forest-transition'
      preLoaderRoute: typeof ServicesForestTransitionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/first-home-buyer': {
      id: '/services/first-home-buyer'
      path: '/services/first-home-buyer'
      fullPath: '/services/first-home-buyer'
      preLoaderRoute: typeof ServicesFirstHomeBuyerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/federal': {
      id: '/services/federal'
      path: '/services/federal'
      fullPath: '/services/federal'
      preLoaderRoute: typeof ServicesFederalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/digital-help': {
      id: '/services/digital-help'
      path: '/services/digital-help'
      fullPath: '/services/digital-help'
      preLoaderRoute: typeof ServicesDigitalHelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/$slug': {
      id: '/profile/$slug'
      path: '/$slug'
      fullPath: '/profile/$slug'
      preLoaderRoute: typeof ProfileSlugRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/preview/shires': {
      id: '/preview/shires'
      path: '/preview/shires'
      fullPath: '/preview/shires'
      preLoaderRoute: typeof PreviewShiresRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locality/$name': {
      id: '/locality/$name'
      path: '/locality/$name'
      fullPath: '/locality/$name'
      preLoaderRoute: typeof LocalityNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn/electorate-v2': {
      id: '/learn/electorate-v2'
      path: '/learn/electorate-v2'
      fullPath: '/learn/electorate-v2'
      preLoaderRoute: typeof LearnElectorateV2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emergency/fire-preparation': {
      id: '/emergency/fire-preparation'
      path: '/emergency/fire-preparation'
      fullPath: '/emergency/fire-preparation'
      preLoaderRoute: typeof EmergencyFirePreparationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/civic/enrol': {
      id: '/civic/enrol'
      path: '/civic/enrol'
      fullPath: '/civic/enrol'
      preLoaderRoute: typeof CivicEnrolRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shire/$name_/transport': {
      id: '/shire/$name_/transport'
      path: '/shire/$name/transport'
      fullPath: '/shire/$name/transport'
      preLoaderRoute: typeof ShireNameTransportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shire/$name_/seniors': {
      id: '/shire/$name_/seniors'
      path: '/shire/$name/seniors'
      fullPath: '/shire/$name/seniors'
      preLoaderRoute: typeof ShireNameSeniorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shire/$name_/schools': {
      id: '/shire/$name_/schools'
      path: '/shire/$name/schools'
      fullPath: '/shire/$name/schools'
      preLoaderRoute: typeof ShireNameSchoolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shire/$name_/profile': {
      id: '/shire/$name_/profile'
      path: '/shire/$name/profile'
      fullPath: '/shire/$name/profile'
      preLoaderRoute: typeof ShireNameProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shire/$name_/housing': {
      id: '/shire/$name_/housing'
      path: '/shire/$name/housing'
      fullPath: '/shire/$name/housing'
      preLoaderRoute: typeof ShireNameHousingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shire/$name_/health': {
      id: '/shire/$name_/health'
      path: '/shire/$name/health'
      fullPath: '/shire/$name/health'
      preLoaderRoute: typeof ShireNameHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shire/$name_/emergency': {
      id: '/shire/$name_/emergency'
      path: '/shire/$name/emergency'
      fullPath: '/shire/$name/emergency'
      preLoaderRoute: typeof ShireNameEmergencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shire/$name_/council': {
      id: '/shire/$name_/council'
      path: '/shire/$name/council'
      fullPath: '/shire/$name/council'
      preLoaderRoute: typeof ShireNameCouncilRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shire/$name_/connectivity': {
      id: '/shire/$name_/connectivity'
      path: '/shire/$name/connectivity'
      fullPath: '/shire/$name/connectivity'
      preLoaderRoute: typeof ShireNameConnectivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shire/$name_/community': {
      id: '/shire/$name_/community'
      path: '/shire/$name/community'
      fullPath: '/shire/$name/community'
      preLoaderRoute: typeof ShireNameCommunityRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ProfileRouteChildren {
  ProfileSlugRoute: typeof ProfileSlugRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
}

const ProfileRouteChildren: ProfileRouteChildren = {
  ProfileSlugRoute: ProfileSlugRoute,
  ProfileIndexRoute: ProfileIndexRoute,
}

const ProfileRouteWithChildren =
  ProfileRoute._addFileChildren(ProfileRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccessibilityRoute: AccessibilityRoute,
  AgricultureRoute: AgricultureRoute,
  CalendarRoute: CalendarRoute,
  ContactRoute: ContactRoute,
  NewHereRoute: NewHereRoute,
  ProfileRoute: ProfileRouteWithChildren,
  SeasonalRoute: SeasonalRoute,
  CivicEnrolRoute: CivicEnrolRoute,
  EmergencyFirePreparationRoute: EmergencyFirePreparationRoute,
  LearnElectorateV2Route: LearnElectorateV2Route,
  LocalityNameRoute: LocalityNameRoute,
  PreviewShiresRoute: PreviewShiresRoute,
  ServicesDigitalHelpRoute: ServicesDigitalHelpRoute,
  ServicesFederalRoute: ServicesFederalRoute,
  ServicesFirstHomeBuyerRoute: ServicesFirstHomeBuyerRoute,
  ServicesForestTransitionRoute: ServicesForestTransitionRoute,
  ServicesGrantsRoute: ServicesGrantsRoute,
  ServicesLegalRoute: ServicesLegalRoute,
  ServicesNdisRoute: ServicesNdisRoute,
  ServicesSeniorsRoute: ServicesSeniorsRoute,
  ServicesSmallBusinessRoute: ServicesSmallBusinessRoute,
  ServicesWhoDoICallRoute: ServicesWhoDoICallRoute,
  ShireNameRoute: ShireNameRoute,
  ShireNameCommunityRoute: ShireNameCommunityRoute,
  ShireNameConnectivityRoute: ShireNameConnectivityRoute,
  ShireNameCouncilRoute: ShireNameCouncilRoute,
  ShireNameEmergencyRoute: ShireNameEmergencyRoute,
  ShireNameHealthRoute: ShireNameHealthRoute,
  ShireNameHousingRoute: ShireNameHousingRoute,
  ShireNameProfileRoute: ShireNameProfileRoute,
  ShireNameSchoolsRoute: ShireNameSchoolsRoute,
  ShireNameSeniorsRoute: ShireNameSeniorsRoute,
  ShireNameTransportRoute: ShireNameTransportRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
